import { gql } from "@apollo/client"

export const GET_GENERAL_SETTINGS_POLICIES = gql`
  query GeneralSettingsPolicies {
    generalSettings {
      cancellationPolicy
      importantInfo
    }
  }
`
